<template>
  <create-content
    v-if="dialog"
    :currentContents="currentContents"
    @closed="dialog = false"
    @submit="didTapSaveContent"
    :enabled="dialog"
    :dialogTitle="dialogTitle"
    :type="type"
  ></create-content>
</template>

<script>
import { addContent } from "@/firebase/api/content";
import CreateContent from "@/components/contents/Create";

export default {
  props: {
    value: Boolean,
    currentContents: Array,
    type: String
  },
  components: { CreateContent },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    dialogTitle() {
      if (this.type === "images") {
        return "Criar nova galeria de imagens";
      }
      if (this.type === "pdf") {
        return "Criar novo texto em PDF ";
      }
      if (this.type === "folder") {
        return "Criar nova pasta de arquivos";
      }
      return "Criar novo conteúdo"
    }
  },
  data: () => ({
    selectedForm: null,
    speedDial: false,
    snackbar: false,
    snackbarColor: "",
    snackbarMessage: ""
  }),
  methods: {
    async didTapSaveContent(content) {
      content.type = this.type;
      this.dialog = false;
      let result = await addContent(this.$route.params.chapterID, content);
      this.snackbarColor = result ? "primary" : "error";
      this.snackbarMessage =
        (result ? "Sucesso ao " : "Erro ao ") + this.dialogTitle.toLowerCase();
      this.snackbar = true;
    }
  }
};
</script>